import PropTypes from 'prop-types';
import React from 'react';
import EditableSectionView from './EditableSectionView';
import ReadOnlySectionView from './ReadOnlySectionView';
import { Section } from '../types';

const SectionView = (props) => {
  const { section, isEducator, isReadOnlyUser } = props;
  if (!section) {
    return null;
  }

  if (isEducator && !isReadOnlyUser) {
    return <EditableSectionView {...props} />;
  }

  return <ReadOnlySectionView {...props} />;
};

SectionView.propTypes = {
  section: Section,
  isEducator: PropTypes.bool,
  educatorOnly: PropTypes.bool,
};

SectionView.defaultProps = {
  isEducator: false,
  educatorOnly: false,
  section: null,
};

export default SectionView;
